const COOLDOWN_MS = 10000;
const VOLUME = 0.35;

let audioContext = null;
let lastPlayTime = 0;
let unlocked = false;

const getContext = () => {
  if (typeof window === 'undefined') return null;
  if (!audioContext) {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    audioContext = new Ctx();
  }
  return audioContext;
};

export const unlockOrderAlertSound = () => {
  const ctx = getContext();
  if (!ctx) return;
  if (ctx.state === 'suspended') ctx.resume();
  unlocked = true;
};

if (typeof window !== 'undefined') {
  const onInteract = () => {
    unlockOrderAlertSound();
    window.removeEventListener('click', onInteract);
    window.removeEventListener('touchstart', onInteract);
    window.removeEventListener('keydown', onInteract);
  };
  window.addEventListener('click', onInteract, { once: true });
  window.addEventListener('touchstart', onInteract, { once: true });
  window.addEventListener('keydown', onInteract, { once: true });
}

const canPlay = () => Date.now() - lastPlayTime >= COOLDOWN_MS;

const playNote = (ctx, frequency, startTime, duration) => {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.value = frequency;
  gain.gain.setValueAtTime(0, startTime);
  gain.gain.linearRampToValueAtTime(VOLUME, startTime + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.001, startTime + duration);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(startTime);
  osc.stop(startTime + duration + 0.05);
};

const playSequence = (notes) => {
  if (!canPlay()) return false;
  const ctx = getContext();
  if (!ctx) return false;
  if (ctx.state === 'suspended' && unlocked) ctx.resume();
  if (ctx.state !== 'running' && !unlocked) return false;

  const now = ctx.currentTime;
  notes.forEach(({ freq, at, dur }) => playNote(ctx, freq, now + at, dur));
  lastPlayTime = Date.now();
  return true;
};

export const playNewOrderSound = () =>
  playSequence([
    { freq: 880, at: 0, dur: 0.12 },
    { freq: 1175, at: 0.14, dur: 0.15 },
  ]);

export const playStaleOrderSound = () =>
  playSequence([
    { freq: 440, at: 0, dur: 0.18 },
    { freq: 330, at: 0.22, dur: 0.22 },
  ]);
